import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import RegistrationService from "../../Services/Registration_Service";
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Paper,
  TextField,
  Box,
  IconButton,
  CircularProgress,
  Button,
  Tooltip,
  Snackbar,
} from "@mui/material";
import { Visibility, Edit } from "@mui/icons-material";
import RegistrationForm from "../Registration/RegistartionForm";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import "../../styles/login.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const MultiStepVendorForm = () => {
  const location = useLocation();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [loginUsername, setLoginUsername] = useState("");
  const [vendors, setVendors] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedVendorId, setSelectedVendorId] = useState(null);
  const [mode, setMode] = useState("");
  const [apiUrl, setApiUrl] = useState("");
  //New 20
  const [vendorStatuses, setVendorStatuses] = useState([]);
  const [showStatusColumn, setShowStatusColumn] = useState(false);

  useEffect(() => {
    const shouldShow =
      Boolean(location.state?.showLoginSuccess) ||
      sessionStorage.getItem("showLoginSuccess") === "true";

    if (shouldShow) {
      const user =
        location.state?.username ||
        sessionStorage.getItem("loginSuccessUser") ||
        sessionStorage.getItem("empname") ||
        sessionStorage.getItem("userEmail") ||
        "User";

      setLoginUsername(user);
      setOpenSnackbar(true);

      sessionStorage.removeItem("showLoginSuccess");
      sessionStorage.removeItem("loginSuccessUser");
      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, document.title, window.location.href);
      }
    }
  }, []);

  // ---------------------- FETCH VENDORS -------------------------
  // const fetchVendors = async (Uname) => {
  //   setLoading(true);
  //   try {
  //     const res = await RegistrationService.getById(Uname);
  //     //console.log("API RESPONSE:", res.data);
  //     setVendors(res?.data ?? []);
  //   } catch {
  //     setVendors([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  //New 20

  const fetchVendors = async (Uname) => {
    setLoading(true);

    try {
      const res = await RegistrationService.getById(Uname);

      const vendorData = res?.data ?? [];

      // Get approval status
      const statusData = await fetchVendorStatuses();

      console.log("REGISTRATION VENDORS =", vendorData);
      console.log("APPROVAL VENDORS =", statusData);

      // Check whether every registration vendor
      // has an approval-status record
      const allVendorsSubmitted =
        vendorData.length > 0 &&
        vendorData.every((vendor) =>
          statusData.some(
            (item) => Number(item.vendorID) === Number(vendor.vendorID),
          ),
        );

      setShowStatusColumn(allVendorsSubmitted);

      // ADD THE CODE HERE
      const vendorsWithStatus = vendorData.map((vendor) => {
        const status = statusData.find(
          (item) => Number(item.vendorID) === Number(vendor.vendorID),
        );

        return {
          ...vendor,
          approvalStatus: status?.aprvrStat || "",
        };
      });

      setVendors(vendorsWithStatus);
    } catch (error) {
      console.error("Error fetching vendors:", error);

      setVendors([]);
      setVendorStatuses([]);
      setShowStatusColumn(false);
    } finally {
      setLoading(false);
    }
  };

  //New 20
  const fetchVendorStatuses = async () => {
    try {
      const response = await RegistrationService.getVendorApprovalStatus();

      const data = response.data || [];

      console.log("APPROVAL STATUS API =", data);

      setVendorStatuses(data);

      return data;
    } catch (error) {
      console.error("Error fetching vendor statuses:", error);

      setVendorStatuses([]);
      return [];
    }
  };

  // ---------------------- INITIAL LOAD (useEffect) -------------------------
  // useEffect(() => {
  //   //debugger;
  //   sessionStorage.removeItem("VendorID"); // clear old vendor-------------------------------

  //   const storedId = sessionStorage.getItem("VendorID");
  //   const Uname = sessionStorage.getItem("userEmail");

  //   if (storedId !== null) {
  //     setSelectedVendorId(parseInt(storedId));
  //     setMode("edit");
  //   } else {
  //     const baseUrl =
  //       sessionStorage.getItem("APIUrl") +
  //       "/api/Registration/Vendorlist"; // 🔥 FIXED URL

  //     setApiUrl(baseUrl);
  //     RegistrationService.setApiUrl(baseUrl);
  //     fetchVendors(Uname);
  //   }
  // }, []);

  //New

  useEffect(() => {
    const loginType = sessionStorage.getItem("LoginType");

    // ==========================================
    // VENDOR LOGIN
    // ==========================================
    if (loginType?.toLowerCase() === "vendor") {
      const vendorIdFromLogin = Number(sessionStorage.getItem("VendorID"));

      // FIRST TIME VENDOR
      // VendorID = 0 means registration is not completed
      if (vendorIdFromLogin === 0) {
        setSelectedVendorId(null);
        setMode("add");
        return;
      }

      // EXISTING VENDOR
      // VendorID > 0 means registration already completed
      const Uname = sessionStorage.getItem("userEmail");

      const baseUrl =
        sessionStorage.getItem("APIUrl") + "/api/Registration/Vendorlist";

      setApiUrl(baseUrl);
      RegistrationService.setApiUrl(baseUrl);

      fetchVendors(Uname);

      return;
    }

    // ==========================================
    // EMPLOYEE / ADMIN
    // EXISTING FLOW
    // ==========================================

    sessionStorage.removeItem("VendorID");

    const storedId = sessionStorage.getItem("VendorID");
    const Uname = sessionStorage.getItem("userEmail");

    if (storedId !== null) {
      setSelectedVendorId(parseInt(storedId));
      setMode("edit");
    } else {
      const baseUrl =
        sessionStorage.getItem("APIUrl") + "/api/Registration/Vendorlist";

      setApiUrl(baseUrl);
      RegistrationService.setApiUrl(baseUrl);

      fetchVendors(Uname);
    }
  }, []);

  const navigate = useNavigate();
  //New
  const loginType = sessionStorage.getItem("LoginType");
  //const vendorId = Number(sessionStorage.getItem("VendorID"));

  // ---------------------- EDIT / VIEW ACTION -------------------------
  const handleAction = (vendor, action) => {
    const id = Number(vendor.vendorID ?? vendor.vendorId ?? 0);

    console.log("Selected Vendor ID =", id);
    console.log("Vendor object =", vendor);

    setSelectedVendorId(id);
    setMode(action);
  };

  const handleAddNewVendor = () => {
    sessionStorage.removeItem("VendorID"); // clear previous vendor
    setSelectedVendorId(null); // ensure form opens blank
    setMode("add"); // set mode to add
  };

  // ---------------------- BACK BUTTON -------------------------
  // const handleBackToList = () => {
  //   //debugger;

  //    sessionStorage.removeItem("VendorID");

  //   setSelectedVendorId(null);
  //   setMode("");

  //   // re-run same logic as useEffect
  //   const Uname = sessionStorage.getItem("userEmail");
  //   const baseUrl =
  //     sessionStorage.getItem("APIUrl") +
  //     "/api/Registration/Vendorlist"; // 🔥 MUST RESET URL

  //   setApiUrl(baseUrl);
  //   RegistrationService.setApiUrl(baseUrl);

  //   fetchVendors(Uname);
  // };

  //New

  const handleBackToList = () => {
    const loginType = sessionStorage.getItem("LoginType");

    // ==========================================
    // VENDOR
    // ==========================================
    if (loginType?.toLowerCase() === "vendor") {
      // DO NOT REMOVE VendorID here
      // VendorID is needed to remember that
      // registration has already been completed.

      setSelectedVendorId(null);
      setMode("");

      const Uname = sessionStorage.getItem("userEmail");

      const baseUrl =
        sessionStorage.getItem("APIUrl") + "/api/Registration/Vendorlist";

      setApiUrl(baseUrl);
      RegistrationService.setApiUrl(baseUrl);

      fetchVendors(Uname);

      return;
    }

    // ==========================================
    // EMPLOYEE / ADMIN
    // ==========================================
    sessionStorage.removeItem("VendorID");

    setSelectedVendorId(null);
    setMode("");

    const Uname = sessionStorage.getItem("userEmail");

    const baseUrl =
      sessionStorage.getItem("APIUrl") + "/api/Registration/Vendorlist";

    setApiUrl(baseUrl);
    RegistrationService.setApiUrl(baseUrl);

    fetchVendors(Uname);
  };

  // ---------------------- FILTER -------------------------
  const filteredVendors = vendors.filter(
    (v) =>
      v.vendorName?.toLowerCase().includes(search.toLowerCase()) ||
      v.vendorMfgLocation?.toLowerCase().includes(search.toLowerCase()),
  );

  //New

  // // ---------------------- FIRST TIME VENDOR -------------------------
  // if (loginType === "Vendor" && vendorId === 0) {
  //   return <RegistrationForm vendorId={0} mode="add" onBack={() => {}} />;
  // }

  // ---------------------- SHOW REGISTRATION FORM -------------------------
  if (selectedVendorId || mode === "add") {
    return (
      <Box sx={{ p: 3 }}>
        {/* New */}
        {/* {loginType?.toLowerCase() !== "vendor" && (
        <Button
          variant="contained"
          onClick={handleBackToList}
          aria-label="Back to vendor list"
          startIcon={<ArrowCircleLeftIcon sx={{ fontSize: 20 }} />}
          sx={{
            mb: 2,
            px: 3,
            py: 1,
            fontSize: "0.95rem",
            textTransform: "none",
            borderRadius: 2,
            fontWeight: 600,
            color: "#fff",
            background: "linear-gradient(90deg, #1976d2 0%, #1565c0 100%)",
            boxShadow: "0 6px 18px rgba(25,118,210,0.18)",
            transition:
              "transform .18s ease, box-shadow .18s ease, background .18s ease",
            "&:hover": {
              transform: "translateY(-3px)",
              boxShadow: "0 10px 30px rgba(21,101,192,0.22)",
              background: "linear-gradient(90deg, #1565c0 0%, #115293 100%)",
            },
          }}
        >
          Back to Vendor List
        </Button>
        )} */}

        {/* <Button
          variant="contained"
          onClick={handleBackToList}
          aria-label="Back to vendor list"
          startIcon={<ArrowCircleLeftIcon sx={{ fontSize: 20 }} />}
          sx={{
            mb: 2,
            px: 3,
            py: 1,
            fontSize: "0.95rem",
            textTransform: "none",
            borderRadius: 2,
            fontWeight: 600,
            color: "#fff",
            background: "linear-gradient(90deg, #1976d2 0%, #1565c0 100%)",
            boxShadow: "0 6px 18px rgba(25,118,210,0.18)",
            transition:
              "transform .18s ease, box-shadow .18s ease, background .18s ease",
            "&:hover": {
              transform: "translateY(-3px)",
              boxShadow: "0 10px 30px rgba(21,101,192,0.22)",
              background: "linear-gradient(90deg, #1565c0 0%, #115293 100%)",
            },
          }}
        >
          Back to Vendor List
        </Button> */}

        {!(
          sessionStorage.getItem("LoginType") === "vendor" && mode === "add"
        ) && (
          <Button
            variant="contained"
            onClick={handleBackToList}
            aria-label="Back to vendor list"
            startIcon={<ArrowCircleLeftIcon sx={{ fontSize: 20 }} />}
            sx={{
              mb: 2,
              px: 3,
              py: 1,
              fontSize: "0.95rem",
              textTransform: "none",
              borderRadius: 2,
              fontWeight: 600,
              color: "#fff",
              background: "linear-gradient(90deg, #1976d2 0%, #1565c0 100%)",
              boxShadow: "0 6px 18px rgba(25,118,210,0.18)",
              transition:
                "transform .18s ease, box-shadow .18s ease, background .18s ease",
              "&:hover": {
                transform: "translateY(-3px)",
                boxShadow: "0 10px 30px rgba(21,101,192,0.22)",
                background: "linear-gradient(90deg, #1565c0 0%, #115293 100%)",
              },
            }}
          >
            Back to Vendor List
          </Button>
        )}

        <RegistrationForm
          vendorId={selectedVendorId}
          mode={mode}
          onBack={handleBackToList}
        />

        
        {/* Login success message for the Registration Form */}
        <Snackbar
          open={openSnackbar}
          autoHideDuration={3000}
          onClose={(event, reason) => {
            if (reason === "clickaway") return;
            setOpenSnackbar(false);
          }}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{
            top: "24px !important",
            right: "24px !important",
            zIndex: 99999,
          }}
        >
          <div className="custom-toast">
            <div className="custom-toast-icon-wrapper">
              <div className="custom-toast-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M5 13l4 4L19 7" />
                </svg>
              </div>
            </div>

            <div className="custom-toast-divider"></div>

            <div className="custom-toast-content">
              <strong>Login successful!</strong> Welcome{" "}
              <span className="toast-email">{loginUsername}</span>
            </div>

            <div className="custom-toast-progress"></div>
          </div>
        </Snackbar>
      </Box>
      // <Box sx={{ p: 3 }}>
      //   <Button variant="outlined" onClick={handleBackToList} sx={{ mb: 2 }}>
      //     ← Back to Vendor List
      //   </Button>
      //   <RegistrationForm
      //     vendorId={selectedVendorId}
      //     mode={mode}
      //     onBack={handleBackToList}
      //   />
      // </Box>
    );
  }

  // ---------------------- VENDOR LIST UI -------------------------
  return (
    <Box sx={{ p: 4, backgroundColor: "#f5f5f5", minHeight: "100vh" }}>
      <Card sx={{ maxWidth: 1000, mx: "auto", borderRadius: 3, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h5" sx={{ mb: 2, fontWeight: "bold" }}>
            Vendor List
          </Typography>

          <Box display="flex" justifyContent="space-between" mb={2}>
            {/* <Button
              variant="contained"
              startIcon={<ArrowBackIcon />}
              onClick={() => navigate("/DashboardFinal")}
            >
              Back to Home
            </Button> */}
            {/* <Button variant="contained" onClick={handleAddNewVendor}>
             + New Vendor
          </Button> */}

            {/* New */}

            {/* BACK TO HOME - EMPLOYEE / ADMIN ONLY */}
            {loginType?.toLowerCase() !== "vendor" && (
              <Button
                variant="contained"
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate("/DashboardFinal")}
              >
                Back to Home
              </Button>
            )}

            {loginType?.toLowerCase() !== "vendor" && (
              <Button variant="contained" onClick={handleAddNewVendor}>
                + New Vendor
              </Button>
            )}
          </Box>

          <TextField
            label="Search Vendor"
            variant="outlined"
            fullWidth
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            sx={{ mb: 3 }}
          />

          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}>
              <CircularProgress />
            </Box>
          ) : (
            <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
              <Table>
                <TableHead sx={{ backgroundColor: "#1976d2" }}>
                  <TableRow>
                    <TableCell sx={{ display: "none" }}>Vendor ID</TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                      Vendor Name
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                      Manufacturing Location
                    </TableCell>
                    {/* new 20 */}
                    {showStatusColumn && (
                      <TableCell
                        sx={{ color: "white", fontWeight: "bold", width: 150 }}
                      >
                        Status
                      </TableCell>
                    )}
                    <TableCell
                      sx={{ color: "white", fontWeight: "bold", width: 150 }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {filteredVendors.length > 0 ? (
                    filteredVendors.map((vendor, index) => (
                      <TableRow key={index} hover>
                        <TableCell sx={{ display: "none" }}>
                          {vendor.vendorId}
                        </TableCell>
                        <TableCell>{vendor.vendorName}</TableCell>
                        <TableCell>{vendor.vendorMfgLocation}</TableCell>

                        {/* new 20 */}
                        {showStatusColumn && (
                          <TableCell>
                            <Chip
                              label={vendor.approvalStatus || "Pending"}
                              size="small"
                              sx={{
                                bgcolor:
                                  vendor.approvalStatus?.toLowerCase() ===
                                  "approved"
                                    ? "#EDF7ED"
                                    : vendor.approvalStatus?.toLowerCase() ===
                                        "rejected"
                                      ? "#FDECEC"
                                      : "#FFF7E6",

                                color:
                                  vendor.approvalStatus?.toLowerCase() ===
                                  "approved"
                                    ? "#2E7D32"
                                    : vendor.approvalStatus?.toLowerCase() ===
                                        "rejected"
                                      ? "#EF4444"
                                      : "#F59E0B",

                                fontWeight: 550,
                                fontSize: "0.93rem",
                                height: 27,
                                borderRadius: "20px",
                                px: 1,
                              }}
                            />
                          </TableCell>
                        )}
                        <TableCell>
                          <IconButton
                            color="primary"
                            onClick={() => handleAction(vendor, "view")}
                          >
                            <Visibility />
                          </IconButton>

                          {/* <IconButton
                            color="secondary"
                            onClick={() => handleAction(vendor, "edit")}
                          >
                            <Edit />
                          </IconButton> */}

                          {/* <IconButton
  color="secondary"
  disabled={vendor.isApprovedByAnyApprover === 1}
  onClick={() => handleAction(vendor, "edit")}
>
  <Edit />
</IconButton> */}

                          {/* <Tooltip
  title={
    vendor.isApprovedByAnyApprover === 1
      ? "Approval in progress — editing disabled."
      : "Edit Vendor"
  }
>
  <span>
    <IconButton
      color="secondary"
      disabled={vendor.isApprovedByAnyApprover === 1}
      onClick={() => handleAction(vendor, "edit")}
    >
      <Edit />
    </IconButton>
  </span>
</Tooltip> */}

                          <Tooltip
                            title={
                              vendor.isApprovedByAnyApprover === 0
                                ? "Vendor cannot be edited after approval/rejection."
                                : "Edit Vendor"
                            }
                          >
                            <span>
                              <IconButton
                                color="secondary"
                                disabled={vendor.isApprovedByAnyApprover === 0}
                                onClick={() => handleAction(vendor, "edit")}
                              >
                                <Edit />
                              </IconButton>
                            </span>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={3} align="center">
                        No vendors found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </CardContent>
      </Card>
      {/* Snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={(event, reason) => {
          if (reason === "clickaway") return;
          setOpenSnackbar(false);
        }}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{
          top: "24px !important",
          right: "24px !important",
          zIndex: 99999,
        }}
      >
        <div className="custom-toast">
          <div className="custom-toast-icon-wrapper">
            <div className="custom-toast-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M5 13l4 4L19 7" />
              </svg>
            </div>
          </div>
          <div className="custom-toast-divider"></div>
          <div className="custom-toast-content">
            <strong>Login successful!</strong> Welcome{" "}
            <span className="toast-email">{loginUsername}</span>
          </div>
          <div className="custom-toast-progress"></div>
        </div>
      </Snackbar>
    </Box>
  );
};

export default MultiStepVendorForm;
